import React from "react";
import { motion } from "framer-motion";

export default function Footer() {
  return (
    <motion.footer
      data-testid="footer"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      viewport={{ once: true }}
      className="bg-[#E5E5E5] text-[#0F0F10] py-6 sm:py-8 px-4 sm:px-6"
    >
      <div className="max-w-7xl mx-auto text-center">
        {/* Logo */}
        <div className="mb-4">
          <img
            src="https://customer-assets.emergentagent.com/job_runner-hub-20/artifacts/b7fales7_icono%20pasteur.png"
            alt="Pasteur Century Run 100"
            className="h-16 sm:h-20 w-auto object-contain mx-auto"
            loading="lazy"
          />
        </div>

        <div className="gold-line w-16 mx-auto mb-4" />

        <p className="font-body text-xs sm:text-sm text-[#6B7280] mb-2">
          Un evento de Clinica Pasteur
        </p>

        <p className="font-body text-[10px] text-[#6B7280]/60">
          &copy; {new Date().getFullYear()} Pasteur Century Run. Todos los derechos reservados.
        </p>
      </div>
    </motion.footer>
  );
}
